import { View, Text, Dimensions, Image, ActivityIndicator } from "react-native";
import React from "react";
import { femaleColor, gray, maleColor, primary, white } from "../../colors";
import { tests, tutorial } from "../../imports";
import translate from "../../functions/translate";
import MyText from "../../components/custom/MyText";
import { useDispatch, useSelector } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  hideBackButton,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useEffect } from "react";
import { useState } from "react";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import TestItem from "../../components/test/TestItem";
import getActiveTestList from "../../api/test/getActiveTestList";
import { ScrollView } from "react-native-gesture-handler";
import LoginFirst from "../../components/custom/LoginFirst";
import GrowthTestItem from "../../components/test/GrowthTestItem";
import MyButton from "../../components/custom/MyButton";
import childrenList from "../../api/get/childrenList";
import NoTestAvailable from "../../components/test/NoTestAvailable";
import TestTitle from "../../components/test/TestTitle";
import getArchiveTestList from "../../api/test/getArchiveTestList";

export default function ArchiveTest() {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const user = useSelector((store) => store.user);
  const [selectedChild, setChild] = useState({
    gender: "male",
    name: "",
    id: null,
  });
  const [childTestsDetails, setChildTestsDetails] = useState(null);
  const [ASQ3Test, setASQ3Test] = useState([]);
  const [ASQSE2Test, setASQSE2Test] = useState([]);
  const [ADHDTest, setADHDTest] = useState([]);
  const [children, setChildren] = useState([]);

  const isFocused = useIsFocused();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#EBD7FF"));
      dispatch(
        showBackButtonWithFunction(() => {
          navigation.goBack();
          navigation.navigate("HomeNavigator");
        })
      );
      childrenList()
        .then(({ data }) => {
          setLoading(false);
          if (data.status === 200) {
            setChildren(data.data);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [isFocused]);
  useEffect(() => {
    if (selectedChild.id !== null) {
      getArchiveTestList(selectedChild.id)
        .then(({ data }) => {
          if (data.status === 200) {
            setASQ3Test(data.ASQ3);
            setADHDTest(data.ADHD);
            setASQSE2Test(data.ASQSE2);
            setChildTestsDetails({
              activeTest: data.activeTest,
              finishedTest: data.finishedTest,
              progressiveTest: data.progressiveTest,
            });
          }
        })
        .catch((err) => {});
    }
  }, [selectedChild, main, isFocused]);

  return (
    <View
      style={{
        width: "100%",
        alignItems: "center",
        flex: 1,
        paddingBottom: 100,
      }}
    >
      <View style={{ alignItems: "center" }}>
        <View
          style={{
            height: Dimensions.get("window").height,
            marginTop: -1 * Dimensions.get("window").height,
            backgroundColor: "#EBD7FF",
            width: "100%",
          }}
        ></View>
        <View style={{ alignItems: "center" }}>
          <View style={{ backgroundColor: "#EBD7FF" }}>
            <View
              style={{
                backgroundColor: "#EBD7FF",
                justifyContent: "center",
                alignItems: "flex-end",
                zIndex: 10,
                width: Dimensions.get("screen").width,
                minHeight: 100,
                flexDirection: "row",
                paddingHorizontal: 5,
              }}
            >
              <View style={{ flex: 4.5 }}>
                <View>
                  <MyText
                    style={{
                      fontSize: 24,
                      marginHorizontal: 10,
                      color: "#504E4E",
                      marginVertical: 10,
                    }}
                  >
                    {translate("test archive")}
                  </MyText>
                </View>
                <View
                  direction={main.rtl ? "rtl" : "ltr"}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                ></View>
              </View>
              <View style={{ flex: 5 }}>
                <Image
                  source={tests}
                  style={{ width: "100%", height: 100 }}
                  resizeMode="contain"
                />
              </View>
            </View>
          </View>
        </View>
      </View>
      {/* {main.token !== null && selectedChild.id === null && (
        <View style={{ width: "100%", alignItems: "center", flex: 1 }}>
          <MyText style={{ marginTop: 10, fontSize: 17 }}>
            {translate("you didn't added any children")}
          </MyText>
          <MyButton
            style={{ marginTop: 10, width: "80%" }}
            text={translate("add children")}
            onPress={() => navigation.navigate("NewChildGenderChoose")}
          />
        </View>
      )} */}
      {loading && (
        <View
          style={{
            flex: 1,
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ActivityIndicator size={"large"} />
        </View>
      )}
      {main.token !== null && children.length !== 0 && (
        <View style={{ width: "100%", alignItems: "center", flex: 1 }}>
          <SelectChildrenMini
            setChild={setChild}
            defaultChild={selectedChild.id}
          />
          <View
            style={{
              marginTop: -15,
              backgroundColor: white,
              width: "96%",
              padding: 5,
              borderRadius: 10,
              borderColor:
                selectedChild.gender === "male" ? maleColor : femaleColor,
              borderWidth: 1.5,
              flex: 1,
              alignItems: "center",
            }}
          >
            <ScrollView
              showsVerticalScrollIndicator={false}
              horizontal={false}
              vertical={true}
              style={{ width: "100%" }}
              contentContainerStyle={{ alignItems: "center" }}
            >
              {/* <TestTitle title={translate("growth")} />
              <GrowthTestItem
                childImage={selectedChild.picURL}
                gender={selectedChild.gender}
                name={selectedChild.name}
                childId={selectedChild.id}
              /> */}
              <TestTitle title="ASQ3" />
              {ASQ3Test.length === 0 && <NoTestAvailable />}
              {ASQ3Test.map((tests) => (
                <TestItem
                  type={"ASQ3"}
                  age={tests.Age}
                  id={tests.id}
                  key={tests.id}
                  gender={selectedChild.gender}
                  name={selectedChild.name}
                  participated={tests.status !== "progressive"}
                  done={tests.status === "finished"}
                  image={selectedChild.picURL}
                  childId={selectedChild.id}
                  price={main.rtl ? tests.priceIR : tests.priceG}
                  dateEnd={
                    tests.status === "finished"
                      ? main.rtl
                        ? tests.dateEndFa.split("-").join("/")
                        : tests.dateFinsh
                      : null
                  }
                />
              ))}
              <TestTitle title="ASQSE2" />
              {ASQSE2Test.length === 0 && <NoTestAvailable />}
              {ASQSE2Test.map((tests) => (
                <TestItem
                  type={"ASQSE2"}
                  age={tests.Age}
                  id={tests.id}
                  key={tests.id}
                  gender={selectedChild.gender}
                  name={selectedChild.name}
                  participated={tests.status !== "progressive"}
                  done={tests.status === "finished"}
                  image={selectedChild.picURL}
                  childId={selectedChild.id}
                  price={main.rtl ? tests.priceIR : tests.priceG}
                  dateEnd={
                    tests.status === "finished"
                      ? main.rtl
                        ? tests.dateEndFa.split("-").join("/")
                        : tests.dateFinsh
                      : null
                  }
                />
              ))}
              <TestTitle title="ADHD" />
              {ADHDTest.length === 0 && <NoTestAvailable />}
              {ADHDTest.map((tests) => (
                <TestItem
                  type={"ADHD"}
                  age={tests.Age}
                  id={tests.id}
                  key={tests.id}
                  gender={selectedChild.gender}
                  name={selectedChild.name}
                  participated={tests.status !== "progressive"}
                  done={tests.status === "finished"}
                  image={selectedChild.picURL}
                  childId={selectedChild.id}
                  price={main.rtl ? tests.priceIR : tests.priceG}
                  dateEnd={
                    tests.status === "finished"
                      ? main.rtl
                        ? tests.dateEndFa.split("-").join("/")
                        : tests.dateFinsh
                      : null
                  }
                />
              ))}

              {/* {childTestsDetails !== null &&
                Object.keys(childTestsDetails.activeTest).map((tests) => {
                  const testsDetails = childTestsDetails.activeTest[tests];

                  if (testsDetails.length === 0 || testsDetails === undefined) {
                    return null;
                  }
                  return testsDetails.map((testDetails) => {
                    return (
                      <TestItem
                        type={tests}
                        age={testDetails.Age}
                        id={testDetails.id}
                        key={testDetails.id}
                        gender={selectedChild.gender}
                        name={selectedChild.name}
                        participated={true}
                        image={testDetails.picURL}
                        childId={selectedChild.id}
                        price={
                          main.rtl ? testDetails.priceIR : testDetails.priceG
                        }
                      />
                    );
                    ``;
                  });
                })}
              {childTestsDetails !== null &&
                Object.keys(childTestsDetails.progressiveTest).map((tests) => {
                  const testsDetails = childTestsDetails.progressiveTest[tests];

                  if (testsDetails.length === 0 || testsDetails === undefined) {
                    return null;
                  }
                  return testsDetails.map((testDetails) => {
                    return (
                      <TestItem
                        type={tests}
                        age={testDetails.Age}
                        id={testDetails.id}
                        key={testDetails.id}
                        gender={selectedChild.gender}
                        name={selectedChild.name}
                        childId={selectedChild.id}
                        participated={false}
                        image={testDetails.picURL}
                        price={
                          main.rtl ? testDetails.priceIR : testDetails.priceG
                        }
                      />
                    );
                    ``;
                  });
                })}
              {childTestsDetails !== null &&
                Object.keys(childTestsDetails.finishedTest).map((tests) => {
                  const testsDetails = childTestsDetails.finishedTest[tests];

                  if (testsDetails.length === 0 || testsDetails === undefined) {
                    return null;
                  }
                  return testsDetails.map((testDetails) => {
                    return (
                      <TestItem
                        price={
                          main.rtl ? testDetails.priceIR : testDetails.priceG
                        }
                        type={tests}
                        age={testDetails.Age}
                        id={testDetails.id}
                        key={testDetails.id}
                        gender={selectedChild.gender}
                        name={selectedChild.name}
                        participated={true}
                        image={testDetails.picURL}
                        childId={selectedChild.id}
                        done={true}
                        dateEnd={
                          main.rtl
                            ? testDetails.dateEndFa.split("-").join("/")
                            : testDetails.dateFinsh
                        }
                      />
                    );
                    ``;
                  });
                })} */}
            </ScrollView>
          </View>
        </View>
      )}
      {!loading && children.length === 0 && main.token !== null && (
        <View
          style={{
            flex: 1,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <MyText style={{ marginVertical: 10, fontSize: 20 }}>
            {translate("noChildYet")}
          </MyText>
          <MyButton
            onPress={() => navigation.navigate("NewChildGenderChoose")}
            style={{ width: "94%", paddingVertical: 20 }}
            text={translate("add children")}
          />
        </View>
      )}

      {main.token === null && <LoginFirst />}
    </View>
  );
}
